module.exports = __webpack_public_path__ + "img/104.afbe3667.jpg";